export default __webpack_public_path__ + "static/media/cosmic-drive.41c0bb43.mp4";